export function GenericDoubleBlindValidation(valueToMatch, rule, value, callback) {
  if (value == null || value === '') {
    callback(new Error('Confirmation required.'));
  } else if (value !== valueToMatch) {
    callback(new Error('The confirmation does not match.'));
  } else {
    callback();
  }
}

export function BooleanTrueValidator(rule, value, callback) {
  const defaultMessage = 'This field has an error';
  if (value !== true) {
    callback(new Error(rule.message ? rule.message : defaultMessage));
  } else {
    callback();
  }
}

export const Username = { pattern: /^[a-zA-Z][a-zA-Z0-9]+$/, message: 'Username must start with a letter and can only contain letters and numbers.', trigger: 'blur' };

export const Integer = { pattern: /^[\d]+$/, message: 'Field may only contain numbers.', trigger: 'blur' };

export const IP = { pattern: /^[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}$/, message: 'IP format is incorrect. ex) 192.1.168.2', trigger: 'blur' };

export const RAFCode = { pattern: /^[A-Z]{3}-[A-Z]{3}-[A-Z]{3}$/, message: 'RAF Code format should be XXX-XXX-XXX', trigger: 'blur' };

export const SSN = { pattern: /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/, message: 'SSN format should be ###-##-####', trigger: 'blur' };

export const Phone = { pattern: /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/i, message: 'Phone format should be in (###) ###-#### format', trigger: 'blur' };

export const Required = { required: true, message: 'This field is required.' };

export const Password = {
  min: 6, max: 30, message: 'Password must be at least 6 characters', trigger: 'blur',
};
